import React from 'react'
import PetitionEdit from '../../components/petitions/PetitionEdit/PetitionEdit'

const PetitionEditPage = () => {
  return (
    <div><PetitionEdit /></div>
  )
}

export default PetitionEditPage